import { z } from 'zod';


export const workingDayFormSchema = z.object({
  name: z.string().min(1, 'schedule:workingDay.validation.nameRequired'),
  workingDays: z.coerce.number().int().min(1, 'schedule:workingDay.validation.workingDaysRequired'),
  offDays: z.coerce.number().int().min(0, 'schedule:workingDay.validation.offDaysRequired'),
  workingDayType: z.coerce.number().int().positive('schedule:workingDay.validation.typeRequired'),
});

export type WorkingDayFormValues = z.infer<typeof workingDayFormSchema>;
